import { MEDICATION_ALERTS_BATCH_UPLOAD } from '../common/Constants';

const BATCH_UPLOAD_ERROR_PREFIX = 'Batch Upload Error:';

/** Returns mapped message for medication batch upload errors; never returns raw backend message. */
export function getMedicationBatchUploadDisplayMessage(rawMessage: string | undefined): string {
  if (!rawMessage || typeof rawMessage !== 'string') {
    return MEDICATION_ALERTS_BATCH_UPLOAD.messages.failed;
  }
  const s = rawMessage.trim();

  if (s.startsWith(BATCH_UPLOAD_ERROR_PREFIX)) {
    return s.slice(BATCH_UPLOAD_ERROR_PREFIX.length).trim();
  }

  for (const m of MEDICATION_ALERTS_BATCH_UPLOAD.errorMappings) {
    const pattern = 'pattern' in m ? (m as any).pattern : (m as any).message;
    const matches =
      s.includes(pattern) &&
      (!('andContains' in m) || s.toLowerCase().includes((m as any).andContains.toLowerCase()));
    if (matches) {
      return m.message;
    }
  }
  return MEDICATION_ALERTS_BATCH_UPLOAD.messages.failed;
}
